<div id="loader">
    <div id="loader-container">
      <div class="loading">
        <div class="loading-1"></div>
        <div class="loading-2"></div>
        <div class="loading-3"></div>
        <div class="loading-4"></div>
      </div>
    </div>
  </div>